import * as React from 'react'
import { ReactComponent as IconOk } from 'assets/images/OkIcon.svg'
import { ListContainer, List, BaseListItem, Decoration } from './Styles'

interface Props {
  show: boolean
  inputValue: string
  data: string[]
  handleClick: (name: string) => void
}

const BaseList = ({ show, inputValue, data, handleClick }: Props) => {
  const isActiveItem = (item: string) => inputValue === item
  if (!show) return null
  return (
    <ListContainer>
      <List>
        {data.map((item, i) => (
          <BaseListItem onClick={() => handleClick(item)} key={i}>
            <Decoration>
              <IconOk style={{ opacity: `${+isActiveItem(item)}` }} />
            </Decoration>
            <p>{item}</p>
          </BaseListItem>
        ))}
      </List>
    </ListContainer>
  )
}

export default React.memo(BaseList)
